export default __webpack_public_path__ + "static/imgAlloy-98b7d41da9a1e6d6b98afc54e336a6b6.webp";